import { render, staticRenderFns } from "./MyPictureDetail.vue?vue&type=template&id=1e22dc65"
import script from "./MyPictureDetail.vue?vue&type=script&lang=js"
export * from "./MyPictureDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports